import { BrowserRouter, useRoutes } from 'react-router-dom';
import { routes, wrapWithSuspense } from './routes';

// 路由渲染组件
const AppRoutes = () => {
  const wrappedRoutes = wrapWithSuspense(routes);
  return useRoutes(wrappedRoutes);
};

// 路由Provider组件
const RouterProvider = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export { routes };
export default RouterProvider;